<template>
  <div class="user_list_page" :a="getWidth">
    <pageTitle />
<!--    <div class="page-header">-->
<!--      <my-form @handle-submit="handleSubmit">-->
<!--        <template slot="default" slot-scope="slotProps">-->
<!--          <a-form-item>-->
<!--            <a-input v-decorator="['keyword']"-->
<!--                     placeholder="请输入效果名称/上传者"-->
<!--                     style="width:200px;margin-right:10px;vertical-align: middle;" />-->
<!--          </a-form-item>-->
<!--          <a-form-item>-->
<!--            <a-select v-decorator="['checkStatus']" placeholder="请选择类型" style="width:150px">-->
<!--              <a-select-option v-for="el in checkStatusSelect" :key="el.value" :value="el.value">{{ el.label }}-->
<!--              </a-select-option>-->
<!--            </a-select>-->
<!--          </a-form-item>-->
<!--        </template>-->
<!--      </my-form>-->
<!--    </div>-->
<!--    <div class="page-main">-->
<!--      <my-table v-bind="{...tableConfig}"-->
<!--                :rowClassName="setRowClassName"-->
<!--                @change="handleTableChange">-->

<!--        &lt;!&ndash;   或者 获取dom 利用 dom hover显示   &ndash;&gt;-->
<!--        <template slot="lightType" slot-scope="text, record, index">-->
<!--          <a-tooltip placement="top"-->
<!--                     :visible="record.conflictReason"-->
<!--                     :title="record.conflictReason"-->
<!--                     :get-popup-container="getPopupContainer">{{ createMaps(lightType, record.lightType) }}-->
<!--          </a-tooltip>-->
<!--        </template>-->
<!--        <template slot="effectType" slot-scope="text, record, index">-->
<!--          <m-image v-if="record.effectType === 'PICTURE'" :url="record.effectUrl" />-->
<!--          <mVideo v-if="record.effectType === 'VIDEO'" :img-url="record.videoCover" :video-url="record.effectUrl" />-->
<!--        </template>-->
<!--        <template slot="action" slot-scope="text, record, index">-->

<!--        <span v-if="record.checkStatus === 'WAIT_CHECK'">-->
<!--           <a-button type="link" @click="() => action(record, 1)">审核通过</a-button>-->
<!--           <a-button type="link" @click="() => action(record, 0)">拒绝</a-button>-->
<!--        </span>-->

<!--          <span v-if="record.checkStatus === 'REJECT'" v-text="record.rejectReason" />-->

<!--        </template>-->
<!--        <template slot="avatar" slot-scope="text, record, index">-->
<!--          <viewer :images="[record.avatar]">-->
<!--            <a-avatar :src="record.avatar" size="large" />-->
<!--          </viewer>-->

<!--        </template>-->
<!--        <template slot="checkStatus" slot-scope="text, record, index">-->
<!--          {{ checkStatusMaps[record.checkStatus] }}-->
<!--        </template>-->
<!--      </my-table>-->
<!--    </div>-->


    <businessGroup  ref="businessGroup"
                    :tableConfig="{...tableConfig}"
                    :formConfig="{...formConfig}"
                    :rowClassName="setRowClassName">
      <template #conflictReason="conflictReason">
        <!-- v-if="conflictReason.conflictReason" -->
        <a-tooltip v-if="conflictReason.conflictReason">
          <template slot="title">
            {{ conflictReason.conflictReason || '暂无' }}
          </template>
          <a-icon type="question-circle" theme="twoTone" />
        </a-tooltip>
      </template>
      <template slot="formSlot" slot-scope="formSlot">
        <a-form-item>
          <a-input v-decorator="['keyword']"
                   placeholder="请输入效果名称/上传者"
                   style="width:200px;margin-right:10px;vertical-align: middle;" />
        </a-form-item>
        <a-form-item>
          <a-select v-decorator="['checkStatus']" placeholder="请选择状态" style="width:150px">
            <a-select-option v-for="el in checkStatusSelect" :key="el.value" :value="el.value">{{ el.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </template>
      <template slot="lightType" slot-scope="record">
        {{ createMaps(lightType, record.lightType) }}
        <!-- <a-tooltip placement="top"
                   :visible="record.conflictReason"
                   :title="record.conflictReason"
                   :get-popup-container="getPopupContainer">{{ createMaps(lightType, record.lightType) }}
        </a-tooltip> -->
      </template>
      <template slot="effectType" slot-scope="record">
        <m-image v-if="record.effectType === 'PICTURE'" :url="record.effectUrl" />
        <mVideo v-if="record.effectType === 'VIDEO'" :img-url="record.videoCover" :video-url="record.effectUrl" />
      </template>
      <template slot="action" slot-scope="record">

        <span v-if="record.checkStatus === 'WAIT_CHECK'">
           <a-button type="link" @click="() => action(record, 1)">审核通过</a-button>
           <a-button type="link" @click="() => action(record, 0)">拒绝</a-button>
        </span>

        <a-button v-if="record.checkStatus === 'REJECT'" @click="() => show(record.rejectReason)" type="link">拒绝原因</a-button>
<!--        <span v-if="record.checkStatus === 'REJECT'"  style="color: #767676" v-text="record.rejectReason" />-->

      </template>
      <template slot="avatar" slot-scope="record">
        <viewer :images="[record.avatar]">
          <a-avatar :src="record.avatar" size="large" />
        </viewer>

      </template>
      <template slot="checkStatus" slot-scope="record">
        {{ checkStatusMaps[record.checkStatus] }}
      </template>
      <template slot="lightEffect" slot-scope="record">
        <div v-if="record.lightType === 'WHITE_LIGHT'">
          <p>亮度: {{ record.brightness || 0 }} %</p>
          <p>色温: {{ record.colorTemperature||0 }} K</p>
          <!--          <p>GM: {{ record.gm }}</p>-->
          <div v-if="record.lightEffect === 'COLOR_TEMPERATURE_PIECE'">
            <p>CTO: {{ record.cto || 0 }} CTO</p>
            <p>CTB: {{ record.ctb || 0 }} CTB</p>
          </div>
        </div>
        <!--   彩光    -->
        <div v-if="record.lightType === 'COLORAMA'">
          <p>亮度: {{ record.brightness || 0 }} %</p>
          <p>CTB: {{ record.ctb || 0 }} CTB</p>
          <!--          <p>HSI亮度: {{ record.intensity }}</p>-->
          <!--          <p>HSI饱和度: {{ record.saturation }}</p>-->
          <!--          <p>HSI色调: {{ record.hue }}</p>-->
          <!--          <div v-if="record.lightEffect === 'RGB'">-->
          <!--            <p>RGB: {{ record.RGB }}</p>-->
          <!--          </div>-->
          <div v-if="record.lightEffect === 'COLOR_COORDINATE'">
            <p>色坐标: {{ record.xtAxis }} {{ record.ytAxis }}</p>
          </div>
        </div>
        <!--   光效     -->
        <div v-if="record.lightType === 'LIGHT_EFFECT'">
          <p>亮度: {{ record.brightness || 0 }} %</p>
          <p>色相: {{ record.hue || 0 }} °</p>
          <p>饱和: {{ record.saturation || 0 }} %</p>
          <p>CTB: {{ record.intensity || 0 }} CTB</p>
        </div>

      </template>
    </businessGroup>

    <a-modal :visible="visibleChange"
             style="margin-bottom: 10px"
             :width="400"
             title="审核"
             class="m-modal"
             @cancel="handleCancel"
             @ok="handleOk"
             :maskClosable="false">
      <div v-if="!actionStatus">
        <a-textarea v-model="rejectReason" :auto-size="{ minRows: 3, maxRows: 5 }" placeholder="请填写不通过的理由" />
      </div>
      <span v-else style="display: block;text-align: center">是否通过该效果的分享</span>
    </a-modal>


    <a-modal :visible="rejectReasonShow"
             style="margin-bottom: 10px"
             :width="400"
             title="拒绝原因"
             @cancel="close"
             class="m-modal"
             :maskClosable="false">
      <span style="display: block;text-align: left">{{ rejectReason }}</span>
      <template slot="footer">
        <a-button @click="close">关闭</a-button>
      </template>
    </a-modal>


  </div>
</template>

<script>
import moment from "moment";
import myForm from "@/components/business/Form/myForm";
import myTable from "@/components/business/Table/myTable";
import mImage from "@/components/business/mImage/mImage";
import mVideo from "@/components/business/mVideo/mVideo";
import pageTitle from "@/components/business/pageTitle";
import businessGroup from "@/components/business/businessGroup";
import { tips } from "@/utils/util";
import { checkStatusMaps, checkStatusSelect, lightType } from "@/utils/pageMaps";

const initial = {
  pageSize: 10,
  current: 1
};

export default {
  components: {
    myForm,
    myTable,
    mImage,
    mVideo,
    pageTitle,
    businessGroup
  },
  data() {
    return {
      lightType,
      checkStatusMaps,
      checkStatusSelect,


      dateFormat: this.$root.$data.dateFormat,
      query: {
        keyword: undefined,	 //搜索关键词：用户昵称、手机号码、邮箱
        startDate: undefined,	// 否 开始日期，格式yyyy-MM-dd
        endDate: undefined,	 // 否结束日期，格式yyyy-MM-dd
        jobId: undefined, // 否 职业ID
        accountStatus: undefined //否  账户状态，可选值：ENABLED（已启用）、DISABLED（已禁用）
      },
      tableConfig: {
        url: 'bluetoothlight/web/effect/lightshares',
        columns: [
          {
            title: "",
            dataIndex: "conflictReason",
            key: "conflictReason",
            align: "center",
            width: 50,
            scopedSlots: { customRender: "conflictReason" },
          },
          {
            title: "类型",
            dataIndex: "lightType",
            key: "lightType",
            align: "center",
            width: 150,
            scopedSlots: { customRender: "lightType" }
          },
          {
            title: "效果名称",
            dataIndex: "effectName",
            key: "effectName",
            align: "center",
            width: 180,
            // scopedSlots: { customRender: "effectName" }
          },
          {
            title: "效果描述",
            dataIndex: "effectDesc",
            key: "effectDesc",
            align: "center",
            width: 150,
            // scopedSlots: { customRender: "effectDesc" }
          },
          {
            title: "效果图片/视频",
            dataIndex: "effectType",
            key: "effectType",
            align: "center",

            scopedSlots: { customRender: "effectType" }
          },
          {
            title: "参数",
            dataIndex: "lightEffect",
            key: "lightEffect",
            align: "center",
            width: 100,
            scopedSlots: { customRender: "lightEffect" }
          },
          {
            title: "头像",
            dataIndex: "avatar",
            key: "avatar",
            align: "center",
            width: 150,
            scopedSlots: { customRender: "avatar" }
          },
          {
            title: "上传者",
            dataIndex: "nickname",
            key: "nickname",
            align: "center",
            width: 180,
            // scopedSlots: { customRender: "nickname" }
          },
          {
            title: "上传时间",
            dataIndex: "createTime",
            key: "createTime",
            width: 180,
            align: "center"
          },
          {
            title: "引用次数",
            dataIndex: "collectNum",
            key: "collectNum",
            width: 100,
            align: "center"
          },
          {
            title: "状态",
            dataIndex: "checkStatus",
            key: "checkStatus",
            width: 100,
            scopedSlots: { customRender: "checkStatus" },
            align: "center"
          },
          {
            title: "操作",
            width: 150,
            scopedSlots: { customRender: "action" },
            align: "center",
          }
        ],
        dataSource: [],
        rowKey: "shareId",
        loading: false
      },
      formConfig: {
        timeShow: true,
        formShow: true
      },
      dataUrl: "bluetoothlight/web/effect/lightshares",


      selectType: [
        { value: 1, label: "全部" },
        { value: 2, label: "待审核" },
        { value: 3, label: "正常" },
        { value: 4, label: "屏蔽" }
      ],
      visible: false,
      rejectReason: '',
      rejectReasonShow: false,
      actionStatus: false,

      loading: false

    };
  },
  created() {
    // this.getData();
  },
  methods: {
    moment,
    // handleSubmit(values) {
    //
    //   if (this.loading) return false;
    //   this.loading = true;
    //
    //   this.query = {
    //     ...this.query,
    //     ...values
    //   };
    //   this.getData();
    //
    //   this.loading = false;
    // },
    show(text) {
      this.rejectReason = text || '已拒绝';
      this.rejectReasonShow = true
    },
    close() {
     this.rejectReason = '';
     this.rejectReasonShow = false
    },
    refreshData() {
      this.$refs?.["businessGroup"]?.getData?.();
    },
    // getData: async function() {
    //   const { current, pageSize } = this.tableConfig.pagination || initial;
    //   this.tableConfig.loading = true;
    //   const res = await this.$get(this.dataUrl, {
    //     ...this.query,
    //     pageNo: current,
    //     pageSize: pageSize
    //   });
    //   const resultData = res?.resultData;
    //   this.tableConfig.dataSource = resultData?.records || [];
    //   if (resultData) {
    //     // this.tableConfig.dataSource = resultData?.records;
    //     // this.setPagination(initial);
    //   }
    //   this.tableConfig.loading = false;
    // },
    // handleTableChange(pagination = {}) {
    //   const { current, pageSize } = pagination;
    //   this.setPagination({ current, pageSize });
    //   this.getData();
    // },
    // setPagination(ops = {}) {
    //   const { pagination } = this.tableConfig;
    //   this.tableConfig.pagination = { ...pagination, ...ops };
    // },
    action: async function(record, status) {

      this.actionStatus = Boolean(status); //判断显示
      this.visible = true; //判断显示
      // this.shareId = shareId;
      // this.visible = true;

      const { shareId } = record;
      if (!shareId || this.loading) return false;
      this.shareId = shareId;
      this.loading = true;
      // const checkStatus = status ? "PASS" : "REJECT";
      // const payload = {
      //   okBack: async () => {
      //     const res = await this.$post(`bluetoothlight/web/effect/lightshares/${shareId}/check`, {
      //       checkStatus
      //     });
      //     const resultStatus = res?.resultStatus;
      //     if (resultStatus) {
      //       tips(this, true);
      //       this.refreshData();
      //     }
      //   },
      //   title: `是否通过该效果`
      // };
      // confirm(this, payload);
      this.loading = false;


    },
    handleOk: async function() {
      const {rejectReason,actionStatus,shareId} = this;
        console.log(this.rejectReason);
      if (!actionStatus && rejectReason == '') {
        tips(this, false, '请输入不通过的理由');
        return false;
      }
      if (this.loading) return false;
      this.loading = true;
      const checkStatus = actionStatus ? "PASS" : "REJECT";
      const res = await this.$post(`bluetoothlight/web/effect/lightshares/${shareId}/check`, {
        checkStatus,
        rejectReason
      });
      const status = res?.resultStatus;
      tips(this, status);
      if (status) {
        this.rejectReason = undefined;
        this.visible = false;
        await this.refreshData();
      }
      this.loading = false;
    },
    handleCancel() {
      this.visible = false;
    },
    createMaps(data, code) {
      return data.reduce((acc, cur) => {
        const { label, value } = cur;
        acc[value] = label;
        return acc;
      }, {})[code] || "";
    },

    setRowClassName(record) {
      const conflictReason = record?.conflictReason;
      if (conflictReason) {
        return "highlight-red";
      }
      return "";

    },
    getPopupContainer(trigger) {
      return trigger.parentElement;
    }
  },
  computed: {
    getWidth() {
      const { columns = [] } = this.tableConfig;
      return columns.reduce((acc = 0, cur) => {
        const { width = 100 } = cur;
        acc += (+(String(width).replace("px", "")));
        return acc;
      }, 0);
    },
    visibleChange() {
      if (!this.visible) {
        this.loading = false;
        this.rejectReason = '';
        this.shareId = undefined;
      }
      return this.visible;
    }
  }
};
</script>

<style lang="less">
.highlight-red {
  background-color: #dd4a68;
  color: #000;
}

.highlight-red:hover td {
  background-color: #e03e2d !important;
  color: #000 !important;
  cursor: pointer;
}

.m-modal {
  .ant-modal-header {
    text-align: center;
  }
}
</style>
<style lang="less" scoped>
.user_list_page {
  .header {
    height: 50px;
    font-size: 24px;
    font-weight: 500;
    border-bottom: 1px solid #eee;
    margin-left: 5px;
  }

  .list_button {
    width: 80px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border: none;
    color: #fff;
    font-size: 12px;
    border-radius: 5px;
    margin-right: 10px;
  }
}
</style>
